import React from "react";
import Tabs from "@mui/material/Tabs";
// import Tab, { TabTypeMap } from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";

interface Props {
  getActiveTab: (tab: number) => void;
  tab: number;
}

export default function ClubTabbar({ getActiveTab, tab }: Props) {
  // const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  //   // setValue(newValue);
  //   getActiveTab(newValue);
  // };

  // useEffect(() => {
  //   getActiveTab(value);
  // });

  // useEffect(() => {
  //   setValue(tab);
  // }, []);

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        width: "100%",
        // border: "1px solid gray",
        "& .MuiTabs-root": {
          minWidth: "100%",
          flexDirection: "row-reverse",
          opacity: 1,
        },
        "& .MuiButtonBase-root": {
          width: "fit-content",
          paddingX: "6px",
        },
      }}
    >
      <Tabs
        style={{
          direction: "rtl",
          display: "flex",

          // border: "1px solid gray",
        }}
        sx={{
          "& .MuiTabs-root": {
            minWidth: "100% !important",
            direction: "ltr",
            // minHeight: "fit-content !important",
          },
        }}
        scrollButtons={false}
        value={tab}
        // onChange={handleChange}
        variant="scrollable"
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
      >
        <CustomTab
          selected={tab === 0}
          handleChangeTab={(index) => getActiveTab(index)}
          index={0}
          label="کلاب "
        />
        <CustomTab
          selected={tab === 1}
          handleChangeTab={(index) => getActiveTab(index)}
          index={1}
          label="ماموریت‌ها"
        />
        <CustomTab
          selected={tab === 2}
          handleChangeTab={(index) => getActiveTab(index)}
          index={2}
          label="جایزه‌ها"
        />
        <CustomTab
          selected={tab === 3}
          handleChangeTab={(index) => getActiveTab(index)}
          index={3}
          label="مدال‌های من"
        />
        <CustomTab
          selected={tab === 4}
          handleChangeTab={(index) => getActiveTab(index)}
          index={4}
          label="تاریخچه"
        />
        <CustomTab
          selected={tab === 5}
          handleChangeTab={(index) => getActiveTab(index)}
          index={5}
          label="راهنما"
        />
      </Tabs>
    </Box>
  );
}

interface ICustomTab {
  label: string;
  index: number;
  selected: boolean;
  handleChangeTab: (index: number) => void;
}

function CustomTab({
  label,
  selected,
  index,
  handleChangeTab,
  ...rest
}: ICustomTab) {
  return (
    <Button
      onClick={() => handleChangeTab(index)}
      sx={{
        borderRadius: "0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        paddingBottom: "5px",
        paddingTop: "10px",
        // border: "1px solid gray",
        minWidth: "90px",
        // textAlign: "center",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          color: selected ? "primary.main" : "info.main",
        }}
      >
        {label}
      </Typography>
      {/* <Box
        sx={{
          flexShrink: 0,
          width: "20px",
          height: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // border: "1px solid gray",
          borderRadius: "50%",
          backgroundColor: "primary.main",
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            color: "background.default",
          }}
        >
          1
        </Typography>
      </Box> */}
    </Button>
  );
}
